// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Set here the theme from Ag Grid
export default {
  agTheme: 'ag-theme-balham-dark',
};
